import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CLERK_CONFIGURED, CLERK_PUBLISHABLE_KEY } from './lib/clerkConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

const routedApp = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Only mount ClerkProvider when a real key exists -- it throws on an empty
// publishableKey, which would take down the whole site, not just /learn.
root.render(
  CLERK_CONFIGURED
    ? <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>{routedApp}</ClerkProvider>
    : routedApp
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
